import { Component, Input, OnInit } from '@angular/core';
import { LineInterface } from '../../../../lines/models/line.interface';
import { SaveMission } from '../../../store/actions/mission.actions';
import { Store } from '@ngrx/store';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';

@Component({
    selector: 'app-cancel-terminate-line',
    templateUrl: './cancel-terminate-line.component.html',
    styleUrls: ['./cancel-terminate-line.component.css'],
    standalone: false
})
export class CancelTerminateLineComponent implements OnInit {

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  formSubmitted: boolean;

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.formSubmitted = false;
  }

  confirmation() {
    if (this.formSubmitted === false) {
      this.formSubmitted = true;
      const cancelTerminateLineInterface = {
        phoneNumber: this.line.phoneNumber,
        step: 1,
        endBillDate: this.line.billEndDate,
      };
      this.store.dispatch(new SaveMission(cancelTerminateLineInterface, this.procedureCode));
    }
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }
}
